<script>
    /*
    	ReviewUpdatePanel.svelte
    */

    import { onMount } from 'svelte';
    import { ID } from '../../common/constants.js';

    // TCARE components
    import TaxonomyFieldsGroup from '../field-groups/TaxonomyFieldsGroup.svelte';
    import ServiceFieldsGroup1 from '../field-groups/ServiceFieldsGroup1.svelte';
    import ServiceFieldsGroup2 from '../field-groups/ServiceFieldsGroup2.svelte';
    import ServiceFieldsGroup3 from '../field-groups/ServiceFieldsGroup3.svelte';
    import ServiceFieldsGroup4 from '../field-groups/ServiceFieldsGroup4.svelte';
    import ServiceFieldsGroup6Stats from '../field-groups/ServiceFieldsGroup6Stats.svelte';
    import ServiceFieldsGroup5Coverage from '../field-groups/ServiceFieldsGroup5Coverage.svelte';

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiChevronRightBox, mdiRestore } from '@mdi/js';

    export let review;                                      // non-store which contains 2 stores

    $: reviewApiData = review.apiData;
    $: leftStore = review.leftServiceObj;                   // Svelte store
    $: leftServiceData = $leftStore.apiData;                // IMPORTANT - must use the apiData!
    $: rightStore = review.rightServiceObj;                 // Svelte store
    $: rightServiceData = $rightStore.apiData;              // IMPORTANT - must use the apiData!

    let rightServiceDataCache = null;

    onMount(() => {
        // console.log('');
        // console.log('ReviewUpdatePanel onMount: ');
        // console.log('review:');
        // console.log(review);

        // use the first leftService if there is one
        if (reviewApiData.leftServices && reviewApiData.leftServices.length > 0) {
            $leftStore.copyApiDataFrom(reviewApiData.leftServices[0]);
        }
        rightServiceDataCache = JSON.parse(JSON.stringify(rightServiceData));           // cache
    })

    
    // for DataTextFields
    const onCopyValue = (propName) => {
        if (propName === ID) return;
        if (!leftServiceData) return;
        rightServiceData[propName] = leftServiceData[propName];
        $rightStore = $rightStore;              // refresh the UI for the field
    }

    // for DataTaxonomyFields
    const onCopyTaxonomy = (taxName, taxObj) => {
        if (!$rightStore.taxonomies[taxName]) return;
        let targetTax = $rightStore.taxonomies[taxName];
        targetTax.copyToForestItems(taxObj);
        $rightStore = $rightStore;              // refresh the UI for the field
    }


    // from left side to right side
    // WHAT ABOUT PREVENTING id FROM BEING COPIED ???
    const copyAllValues = () => {
        $rightStore.copyApiDataFrom(leftServiceData);
        $rightStore = $rightStore;              // refresh the UI for the field
    }

    // right side resets itself - no copying from left
    const resetAllValues = () => {
        $rightStore.copyApiDataFrom(rightServiceDataCache);
        $rightStore = $rightStore;              // refresh the UI for the field
    }

</script>

<style>
    .review-update-panel {
        width: 100%;
        /* border: 1px solid green; */
        /* box-shadow: 1px 1px 1px var(--tcare-primary); */
    }

    /* these CSS classes should go in a common area! */

    .flex-block {
        overflow: hidden;
    }

    .left-form {
        background-color: var(--tcare-left-bg);
        border-radius: 18px;
    }

    .right-form {
        background-color: var(--tcare-right-bg);        
        border-radius: 18px;
    }

    .copy-reset-all {
        font-size: 14px;
        padding: 10px 15px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .copy-reset-all.left-header {
        background-color: var(--tcare-dull-purple);
    }

    .copy-reset-all.right-header {
        background-color: var(--tcare-purple-3);
    }


    :global(.copy-reset-all svg) {
        width: 24px;
        margin-left: 10px;
        font-size: 10px;
        fill: var(--tcare-white);
        outline: none;
    }

    :global(.copy-reset-all svg:hover) {
        fill: var(--tcare-secondary);
    }

    .review-type {
        font-size: 18px;
        font-weight: normal;
    }

    .padded-fields {
        padding: 20px;
    }

    .service-name {
        width: 70%;
        padding: 10px 0px 20px 0px;
        font-size: 15px;
        font-weight: 800;
    }

    /* this is how to style the individual data fields */
    /* :global(.review-update-panel .data-taxonomy-field .value) { */
        /* width: 60%; */
        /* border: 1px solid red; */
    /* } */

    :global(.review-update-panel .fields-area .flex-block.w-49) {
        width: 100% !important;
        max-width: 100% !important;
    }
    

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


{#if leftServiceData && rightServiceData}
<div class="review-update-panel flex-row ai-start">
    
    <!-- source set to LEFT SERVICE - block header and CopyAll() icon -->
    <div class="flex-block left-form w-49">
        <div class="copy-reset-all left-header" on:click={copyAllValues}>
            <div class="flex-row review-type">Current Service</div>
            <div class="flex-row jc-end w-50">
                Copy all fields
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiChevronRightBox} /></Icon>
            </div>
        </div>

        <div class="padded-fields">
            <div class="service-name">{leftServiceData.serviceName}</div>

            <div class="flex-row ai-start">
                <TaxonomyFieldsGroup
                    store={leftStore}
                    leftService={leftServiceData}
                    rightService={rightServiceData}
                    onCopyTaxonomy={onCopyTaxonomy}
                    isEditable={false}
                    isOpen={true}
                    showTcareTax1={true}
                    showDiffs={true}
                />
            </div>
        
            <ServiceFieldsGroup1
                bind:store={leftStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={onCopyValue}
                isEditable={false}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup2
                bind:store={leftStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={onCopyValue}
                isEditable={false}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup3
                bind:store={leftStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={onCopyValue}
                isEditable={false}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup4
                bind:store={leftStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={onCopyValue}
                isEditable={false}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup5Coverage
                bind:store={leftStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={onCopyValue}
                isEditable={false}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup6Stats
                bind:store={leftStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={onCopyValue}
                isEditable={false}
                isOpen={false}
                showDiffs={true}
            />

        </div>
    </div>

    <!-- source set to RIGHT SERVICE - block header and ResetAll() icon  -->
    <div class="flex-block right-form w-49">
        <div class="copy-reset-all right-header" on:click={resetAllValues}>
            <div class="flex-row review-type">Suggested updates</div>
            <div class="flex-row jc-end w-50">
                Reset all fields
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiRestore} /></Icon>
            </div>
        </div>

        <div class="padded-fields">
            <div class="service-name">{leftServiceData.serviceName}</div>

            <div class="flex-row ai-start">
                <TaxonomyFieldsGroup
                    store={rightStore}
                    leftService={leftServiceData}
                    rightService={rightServiceData}
                    onCopyTaxonomy={null}
                    isEditable={true}
                    isOpen={true}
                    showTcareTax1={true}
                    showDiffs={true}
                />
            </div>

            <ServiceFieldsGroup1
                bind:store={rightStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={null}
                isEditable={true}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup2
                bind:store={rightStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={null}
                isEditable={true}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup3
                bind:store={rightStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={null}
                isEditable={true}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup4
                bind:store={rightStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={null}
                isEditable={true}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup5Coverage
                bind:store={rightStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={null}
                isEditable={true}
                isOpen={true}
                showDiffs={true}
            />
            <ServiceFieldsGroup6Stats
                bind:store={rightStore}
                leftService={leftServiceData}
                rightService={rightServiceData}
                onCopyValue={null}
                isEditable={true}
                isOpen={false}
                showDiffs={true}
            />

        </div>
    </div>
</div>
{/if}
